<script setup lang="ts">
import { computed } from "vue";

import { cardKey } from "@/components/StickyNote/injectKeys";
import SetWsjf from "@/components/menu/SetWsjf/SetWsjf.vue";
import { useServerSettingsStore } from "@/store/serverSettings";
import { injectStrict } from "@/utils/vue";

import AttributeChip from "./AttributeChip.vue";

const card = injectStrict(cardKey);

const priority = computed(() =>
  card.type.priorities ? card.type.priorities[card.priority]?.text || "" : card.priority.toString(),
);

const tooltipKey = useServerSettingsStore().isPriorityEditable
  ? /*$t*/ "actions.wsjf"
  : /*$t*/ "actions.wsjfWarning";
</script>

<template>
  <AttributeChip
    name="wsjf-chip"
    :text="priority"
    :tooltip="$t(tooltipKey)"
    :readonly="!useServerSettingsStore().isPriorityEditable"
    :dropdown-props="{ width: 'auto' }"
  >
    <SetWsjf />
  </AttributeChip>
</template>
